<div class="bcWrapper"
     *ngrxLet="breadcrumbs$; let breadcrumbs">

  <div class="flex flex-row items-center">
    <!--    Show the back button only if there are at least 2 lvls-->
    @if (breadcrumbs.length > 1) {
      <button mat-icon-button class="mr-4 hover:bg-neutral-90"
              (click)="navigate(breadcrumbs[breadcrumbs.length - 2])">
        <mat-icon svgIcon="arrow_back"></mat-icon>
      </button>
    }

    <!--    Show Breadcrumbs only if there are no (0) selected items and at least 2 lvls -->
    @if (!selectedItems && breadcrumbs.length > 1) {
      <div class="flex flex-col">
        <div class="flex">
          @for (bc of breadcrumbs; track bc; let last = $last) {
            <div>
              @if (!last) {
                <div class="h-4 flex flex-row items-center">
                  <span class="text-body-small text-neutral-30
                               cursor-pointer"
                        (click)="navigate(bc)">{{ getLabel(bc['title']) }}</span>
                  @if (!last) {
                    <mat-icon class="text-neutral-60 text-[12px]
                                     h-4 w-4
                                     flex items-center justify-center"
                              svgIcon="chevron_right">
                    </mat-icon>
                  }
                </div>
              }
            </div>
          }
        </div>
        <span class="text-headline-small text-neutral-10">{{ getLabel(
            breadcrumbs[(breadcrumbs.length - 1)]['title']) }}</span>
      </div>
    }

    <!--    Show the amount of selected items if there are any-->
    @if (selectedItems) {
      <div class="text-title-small whitespace-pre-line box-border
                  pr-[10px]">
        <p>
          <span>{{ selectedItems | number:'1.0-0':translate.currentLang }}</span>
          <span>{{' ' + ((selectedItems > 1) ? (itemName + 's')
            : itemName)
          + ' selected'}}</span>
        </p>
      </div>
    }
  </div>

  <!--  Show just the page/section name (and total items) if there is just 1 lvl-->
  @if (breadcrumbs.length <= 1 && !selectedItems) {
    <div class="flex">
      <span class="text-headline-small text-neutral-10">{{
          getLabel(
          breadcrumbs[0]['title']) }}</span>
    </div>
    @if (!!itemsTotal) {
      <div class="totalItems">{{ itemsTotal }}</div>
    }
  }

</div>


